import styled from "@emotion/styled";
import React from "react";
import { CHEVRON_RIGHT_ICON } from "../../utils/svgs_new";
import { AppIcon } from "../Generic/AppIcon";

interface Props {
  onClick?: () => void;
}

const NextButton = (props: Props) => {
  return (
    <NextButton.Styled onClick={props.onClick} className="NextButton">
      <AppIcon icon={CHEVRON_RIGHT_ICON} size={10} />
    </NextButton.Styled>
  );
};

NextButton.Styled = styled.div`
  --size: 32px;
  background: var(--gray-50);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--size);
  height: var(--size);
`;

export default NextButton;
